import { useProviderServicesPermissions } from "../../hooks/useProviderServicesPermissions";
import useServicesButtonActions from "../../hooks/useServicesButtonActions";
import { useServicesStore } from "../../store/services-provided/servicesStore";
import LeftNavigation from "../buttons/LeftNavigation";
import RightNavigation from "../buttons/RightNavigation";

export default function ServiceMovementButtons() {
  const { selectedAvailableServices, selectedProvidedServices } = useServicesStore();
  const { handleOnClickLeftNavigation, handleOnClickRightNavigation } = useServicesButtonActions();
  const { canAddProviderServices, canDeleteProviderServices } = useProviderServicesPermissions();
  return (
    <div className="flex h-full flex-col items-center justify-center gap-2">
      <LeftNavigation
        disabled={selectedProvidedServices.length === 0 && canDeleteProviderServices}
        handleOnClick={handleOnClickLeftNavigation}
      />
      <RightNavigation
        disabled={selectedAvailableServices.length === 0 && canAddProviderServices}
        handleOnClick={handleOnClickRightNavigation}
      />
    </div>
  );
}
